import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../abstract.effects';
import { SponsorshipService } from '../../services/sponsorship.service';
import { ESponsoredListActions, GetSponsoredList, GetSponsoredListSuccess } from '../actions/sponsored-list.actions';
import { SponsoredListPaginatorInterface } from '../../models/sponsored.list.paginator.interface';

@Injectable()
export class SponsoredListEffects extends AbstractEffects {

    currentSelectedPage: number;
    totalItemsPerPage: number;

    constructor(
        private actions: Actions,
        private sponsorshipService: SponsorshipService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getSponsoredList = createEffect(() => this.actions.pipe(
        ofType<GetSponsoredList>(ESponsoredListActions.GetSponsoredList),
        tap(params => {
            this.currentSelectedPage = params.currentSelectedPage;
            this.totalItemsPerPage = params.totalItemsPerPage;
        }),
        switchMap(() => this.sponsorshipService.getSponsoredList(this.currentSelectedPage, this.totalItemsPerPage)),
        switchMap((response: SponsoredListPaginatorInterface) => of(new GetSponsoredListSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            return throwError(error);
        })
    ));
}
